module.exports = __webpack_public_path__ + "img/footer_shape.bdb98dca.svg";